import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar"
import Home from "./components/home";
import Ourproject from "./components/ourproject"
import Description from "./components/description"
import HappyCustomers from "./components/testimonial";
import Contact from "./components/contact"
import CostEstimator from "./components/cost";
function App() {
   return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Ourproject" element={<Ourproject />} />
         <Route path="/HappyCustomers" element={<HappyCustomers />} />
         <Route path="/Contact" element={<Contact />} />
            <Route path="/CostEstimator" element={<CostEstimator />} />
        <Route path="/Ourproject/description" element={<Description />} />
      </Routes>
    </Router>
  );
}

export default App;